import { Field, Label } from "V2.0/common/fieldset";
import { Listbox, ListboxOption, ListboxLabel } from "V2.0/common/listbox";
import DefaultEndForm from "../Default/DefaultEndForm";
import { ArchiveReason } from "../../../Models/End";

export default ArchiveConversationForm;

const archiveReasonLabels = {
  [ArchiveReason.ERROR]: "Error",
  [ArchiveReason.MANUAL]: "Manual",
  [ArchiveReason.OTHER]: "Other",
  [ArchiveReason.RESOLVED]: "Resolved",
  [ArchiveReason.TIMED_OUT]: "Timed Out",
};

const archiveReasonOptions = Object.values(ArchiveReason).map(
  (archiveReason, idx) => {
    return {
      id: idx,
      value: archiveReason,
      label: archiveReasonLabels[archiveReason],
    };
  },
);

function ArchiveConversationForm(props) {
  const { formState, errors, updateFormState } = props;

  return (
    <div className="space-y-8">
      <DefaultEndForm
        formState={formState}
        errors={errors}
        updateFormState={updateFormState}
      />

      <Field>
        <Label>Archive Reason</Label>
        <Listbox
          as="div"
          className="my-4"
          value={formState.archiveReason}
          defaultValue={formState.archiveReason}
          invalid={!!errors.archiveReason}
          onChange={(value) => updateFormState("archiveReason", value)}
        >
            {archiveReasonOptions.map((archiveReasonOption) => {
                return <ListboxOption key={archiveReasonOption.id} value={archiveReasonOption.value}>
                    <ListboxLabel>{archiveReasonOption.label}</ListboxLabel>
                </ListboxOption>
            })}
        </Listbox>
      </Field>
    </div>
  );
}
